import {
  getAdyenEnvironment,
  getAdyenErrorMessage,
} from 'lib/adyen'
import { adyenTranslations } from '~/data/adyen-translations'

export function useAdyenSupportFunctions(emit?: any) {
  const {
    public: { adyenEnvironment },
  } = useRuntimeConfig()
  const router = useRouter()
  const { $checkoutUrl, $t } = useNuxtApp()
  const route = useRoute()
  const checkoutStore = useCheckoutStore()
  const gtm = useGTM()
  const storefrontStore = useStorefrontStore()
  const { countryCode } = storefrontStore.currentMarket

  async function handleServerResponse(res: Adyen.PaymentSessionResponse, component: any) {
    if (res.action) {
      component.handleAction(res.action)
    }
    else {
      switch (res.resultCode) {
        case 'Authorised':
          await router.push($checkoutUrl({ route, view: 'success', orderId: '' }))
          break
        case 'Received':
        case 'Pending':
          checkoutStore.loading = false
          await router.push($checkoutUrl({ route, view: 'success', orderId: '' }))
          break
        case 'Refused':
        case 'Cancelled':
          gtm.pushPaymentCancelEvent()
          checkoutStore.loading = false
          emit('paymentError', getAdyenErrorMessage(res.resultCode, $t))
          break
        default:
          break
      }
    }
  }

  const getEnvironment = () => getAdyenEnvironment(countryCode, adyenEnvironment)

  const getAdyenLanguage = (localHTML: string) => {
    const lang = localHTML.split('-')[1].toLocaleLowerCase()
    return adyenTranslations[lang]
  }

  return {
    handleServerResponse,
    getEnvironment,
    getAdyenLanguage,
  }
}
